import { useCallback } from 'react';

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready: (callback: () => void) => void;
        execute: (siteKey: string, options: { action: string }) => Promise<string>;
      };
    };
  }
}

const RECAPTCHA_SITE_KEY = '6Lfj5xYsAAAAAPvUfkHhTZ4-RLDGvLfcpT30yTdc';

export const useRecaptcha = () => {
  const executeRecaptcha = useCallback(async (action: string): Promise<string | null> => {
    // Check if reCAPTCHA is disabled via environment variable
    const recaptchaActive = process.env.REACT_APP_RECAPTCHA_ACTIVE?.toUpperCase();
    if (recaptchaActive === 'FALSE') {
      console.log(`reCAPTCHA verification skipped (REACT_APP_RECAPTCHA_ACTIVE=FALSE) for action: ${action}`);
      return 'dummy-token'; // Return a dummy token when reCAPTCHA is disabled
    }

    return new Promise((resolve) => {
      if (!window.grecaptcha?.enterprise) {
        console.warn('reCAPTCHA not loaded');
        resolve(null);
        return;
      }

      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
            action: action
          });
          resolve(token);
        } catch (error) {
          console.error('reCAPTCHA execution failed:', error);
          resolve(null);
        }
      });
    });
  }, []);

  return { executeRecaptcha };
}; 